var _defs, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeHeader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.023,
    height: 43.022,
    viewBox: "0 0 43.023 43.022",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.bRJDsdaff{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H43.023V43.022H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "bRJDsdaff",
    d: "M15.705,31.408V22.445h7.171v8.963A1.8,1.8,0,0,0,24.668,33.2h5.378a1.8,1.8,0,0,0,1.793-1.793V18.86h3.047a.889.889,0,0,0,.592-1.56L20.492,3.8a1.806,1.806,0,0,0-2.4,0L3.1,17.3a.893.893,0,0,0,.592,1.56H6.742V31.408A1.8,1.8,0,0,0,8.535,33.2h5.378A1.8,1.8,0,0,0,15.705,31.408Z",
    transform: "translate(2.221 2.651)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeHeader);
export default __webpack_public_path__ + "static/media/home-header.7c5d8d3a.svg";
export { ForwardRef as ReactComponent };